import { type JSX, type ReactNode, useState } from 'react';

import { faCircleCheck, faCircleExclamation, faCircleInfo, faCircleXmark } from '@awesome.me/kit-24322b77ac/icons/classic/solid';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import classNames from 'classnames';

import { CloseButton } from '../Button/CloseButton';
import { Icon } from '../Icon/Icon';

import './Alert.less';

type AlertType = (readonly ['success', 'info', 'warning', 'error'])[number];

interface AlertProps {
  type: AlertType;
  closable?: boolean;
  children: ReactNode;
  style?: React.CSSProperties;
}

const TypeToIcon: { [key in AlertType]: IconDefinition } = {
  success: faCircleCheck,
  error: faCircleXmark,
  info: faCircleInfo,
  warning: faCircleExclamation,
};

const AlertIcon = ({ type }: { type: AlertProps['type'] }): JSX.Element => {
  return <Icon className="alert-icon" icon={TypeToIcon[type]} />;
};

export const Alert = ({ children, type, closable, style }: AlertProps): JSX.Element => {
  const [isHidden, setIsHidden] = useState<boolean>(false);

  return (
    <div className="alert-wrapper" style={{ display: isHidden ? 'none' : 'block', ...style }}>
      <div className={classNames('alert', `alert-${type}`, { 'alert-closable': closable })}>
        <AlertIcon type={type} />
        <div className="alert-message">{children}</div>
        {closable && <CloseButton onClick={() => setIsHidden(true)} />}
      </div>
    </div>
  );
};
